// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/id"; // Impor locale Bahasa Indonesia untuk Day.js
import ProtectedRoute from "./components/ProtectedRoute";
import SignIn from "./pages/SignIn";
// import MenuHomeSurveyor from "./pages/MenuHomeSurveyor";
import MenuHome from "./pages/MenuHome";
import Kehadiran from "./pages/Kehadiran";
import MenuAbsensi from "./pages/MenuAbsensi";
import FormAbsensiSurveyor from "./pages/FormAbsensiSurveyor";
import FormForeman from "./pages/FormForeman";
import FormLaporanHarian from "./pages/FormLaporanHarian";
import FormLaporanKerusakan from "./pages/FormLaporanKerusakan";
import MenuRiwayatLaporan from "./pages/MenuRiwayatLaporan";
import DetailLaporan from "./pages/DetailLaporan";
import FormCheckListDrone from "./pages/FormChecklistDrone";
import ProfilMenu from "./pages/ProfilMenu";
import ProfilKaryawan from "./pages/ProfilKaryawan";
import MenuDroneChecklist from "./pages/MenuDroneChecklist";
import DetailChecklistDrone from "./pages/DetailChecklistDrone";
import UbahKataSandi from "./pages/UbahKataSandi";
import MenuLaporanSafety from "./pages/MenuLaporanSafety";
import FormInspeksi from "./pages/FormInspeksi";
import FormObservation from "./pages/FormObservation";
import MenuAlat from "./pages/MenuAlat";
import FormFollowupKerusakan from "./pages/FormFollowupKerusakan";

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="id">
      <Router>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/menu" element={<MenuHome />} />
            <Route path="/kehadiran" element={<Kehadiran />} />
            <Route path="/menu-absensi" element={<MenuAbsensi />} />
            <Route
              path="/absensi-hadir-p5m"
              element={<FormAbsensiSurveyor />}
            />
            <Route path="/absensi-materi-safety" element={<FormForeman />} />
            <Route
              path="/form-laporan-harian"
              element={<FormLaporanHarian />}
            />
            <Route path="/menu-alat" element={<MenuAlat />} />
            <Route
              path="/form-laporan-kerusakan"
              element={<FormLaporanKerusakan />}
            />
            <Route
              path="/menu-riwayat-laporan"
              element={<MenuRiwayatLaporan />}
            />
            <Route
              path="/detail/:reportType/:reportId"
              element={<DetailLaporan />}
            />
            <Route
              path="/form-checklist-drone"
              element={<FormCheckListDrone />}
            />
            <Route path="/profil-menu" element={<ProfilMenu />} />
            <Route path="/profil-karyawan" element={<ProfilKaryawan />} />
            <Route
              path="/menu-drone-checklist"
              element={<MenuDroneChecklist />}
            />
            <Route
              path="/detail-checklist-drone/:id"
              element={<DetailChecklistDrone />}
            />
            <Route path="/ganti-password" element={<UbahKataSandi />} />
            <Route path="/laporan-safety" element={<MenuLaporanSafety />} />
            <Route path="/detail-inspeksi/:id" element={<DetailLaporan />} />
            <Route path="/detail-observasi/:id" element={<DetailLaporan />} />
            <Route path="/form-inspeksi" element={<FormInspeksi />} />
            <Route path="/form-observasi" element={<FormObservation />} />
            <Route path="/form-followup-kerusakan/:id" element={<FormFollowupKerusakan />} />
          </Route>
        </Routes>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
